<div class="column twelve pad-top-10 pad-bottom-10" [formGroup]="newAddressForm">
  <div class="row">
    <div class="column twelve md-six paddedInput">
      <ds-form-control-container
        labelText="Street Address"
        [control]="newAddressForm.controls['addressLine1Input']"
      >
        <input
          type="text"
          id="addressLine1Input"
          class="fill"
          formControlName="addressLine1Input"
          [(ngModel)]="address.addressLine1"
        />
        <ds-form-control-message
          [control]="newAddressForm.controls['addressLine1Input']"
        ></ds-form-control-message>
      </ds-form-control-container>
    </div>
    <div class="column twelve md-six paddedInput">
      <ds-form-control-container
        labelText="Street Address 2 (Optional)"
        [control]="newAddressForm.controls['addressLine2Input']"
      >
        <input
          type="text"
          id="addressLine2Input"
          class="fill"
          formControlName="addressLine2Input"
          [(ngModel)]="address.addressLine2"
        />
        <ds-form-control-message
          [control]="newAddressForm.controls['addressLine2Input']"
        ></ds-form-control-message>
      </ds-form-control-container>
    </div>
  </div>
  <div class="row">
    <div class="column twelve md-five paddedInput">
      <ds-form-control-container labelText="City" [control]="newAddressForm.controls['cityInput']">
        <input
          type="text"
          id="cityInput"
          class="fill"
          formControlName="cityInput"
          [(ngModel)]="address.city"
        />
        <ds-form-control-message
          [control]="newAddressForm.controls['cityInput']"
        ></ds-form-control-message>
      </ds-form-control-container>
    </div>
    <div class="column twelve md-five paddedInput">
      <ds-form-control-container
        labelText="State"
        [control]="newAddressForm.controls['stateInput']"
      >
        <select
          id="stateInput"
          class="icon fill"
          formControlName="stateInput"
          [(ngModel)]="address.state"
        >
          <option value=""></option>
          @for (state of states; track state) {
            <option [value]="state.value">{{ state.name }}</option>
          }</select
        ><span class="icon-chevron-down"></span>
        <ds-form-control-message
          [control]="newAddressForm.controls['stateInput']"
        ></ds-form-control-message>
      </ds-form-control-container>
    </div>
    <div class="column twelve md-two paddedInput">
      <ds-form-control-container
        labelText="Zipcode"
        [control]="newAddressForm.controls['zipcodeInput']"
      >
        <input
          type="text"
          id="zipcodeInput"
          class="fill"
          formControlName="zipcodeInput"
          [(ngModel)]="address.zipCode"
        />
        <ds-form-control-message
          [control]="newAddressForm.controls['zipcodeInput']"
        ></ds-form-control-message>
      </ds-form-control-container>
    </div>
  </div>
  <div class="row">
    <div class="column six text-left pad-top-10">
      @if (hasDuplicateAddress) {
        <div class="color-red">Address already exist</div>
      }
    </div>
    <div class="column six text-right paddedInput pad-top-10">
      <button
        ds-button
        [disabled]="!newAddressForm.valid"
        (click)="$event.preventDefault(); addAddress()"
      >
        Use this address
      </button>
    </div>
  </div>
</div>
